<template>
  <div>
    <va-card class="bg-black">
      <div class="row justify--space-between" style="margin: 0 !important;">
        <h5>{{ $t('checkup_plus.rules.title') }} </h5>
        <span class="is-bold">{{ limitRules.length > 0 ? `${$t(`checkup_plus.person.rules.total_rules`)} ${limitRules.length}` : $t('checkup_plus.person.rules.no_rules') }} &nbsp;
          <i class="clickable" :class="{'fa fa-chevron-down' : isCollapsed, 'fa fa-chevron-up': !isCollapsed}"
             style="color: #1ED78D"
             @click.prevent="isCollapsed = !isCollapsed"
          >
          </i>
        </span>
      </div>
      <div v-if="!isCollapsed" class="col-12" style="margin:0 !important;">
        <v-client-table
          v-if="limitRules.length > 0"
          id="limitRulesTable"
          ref="limitRulesTable"
          name="limitRulesTable"
          :data="limitRules"
          :columns="columns"
          :options="tableOptions">
            <span slot="createdAt" slot-scope="{row}">
              {{ row.createdAt ? moment(row.createdAt).format("YYYY/MM/DD HH:mm") : "N/A" }}
            </span>

            <span slot="alarmType" slot-scope="elem">
              {{ $t(`checkup_plus.alerts.alarmTypes.${elem.row.alarmType.alarmTypeId}`) }}
            </span>

            <span slot="limitType" slot-scope="elem">
              {{ $t(`checkup_plus.person.rules.rule_creation.limit_types_options.${elem.row.limitType.limittypeId}`) }}
            </span>

          <span slot="criteria" slot-scope="elem">
              {{elem.row.chartResult ? handleCriteriaLabel(elem.row.chartResult) : "N/A" }}
          </span>

          <span slot="entityEmails" slot-scope="elem">
              {{handleEntityEmails(elem.row.entityEmails)}}
          </span>

          <span slot="actions" slot-scope="elem">
            <va-popover
              placement="top"
              :message="$t('facility.delete')">
              <i class="fa fa-trash" @click="handleDeleteRule(elem.row)"/>
            </va-popover>
          </span>
        </v-client-table>

        <div class="row d-flex justify-content-end">
          <va-button
            :disabled="showCreateRuleModal"
            @click.prevent="createNewRule">
            <va-popover
              :message="$t('checkup_plus.person.rules.create_rule')"
              placement="top"
            >
              <i class="fa fa-plus"/>
            </va-popover>
          </va-button>
        </div>
      </div>
    </va-card>

    <CreateRuleModal
      v-if="showCreateRuleModal"
      :person="person"
      :allowedMeasurementGroups="allowedMeasurementGroups"
      @cancel="showCreateRuleModal = false"
      @ruleCreated="handleRuleCreated"
    >

    </CreateRuleModal>
  </div>
</template>

<script>
import {ClientTable} from 'vue-tables-2'
import Vue from "vue";
import {OneCareService} from "@/api/OneCareService";
import CreateRuleModal from "@/components/checkup_plus/patients/rules/CreateRuleModal.vue";

Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  components: {CreateRuleModal},
  props: {
    person: {
      type: Object,
      required: true
    },
    limitRules: {
      type: Array,
      required: true,
      default: []
    },
    allowedMeasurementGroups: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: function () {
    return {
      isCollapsed: true,
      showCreateRuleModal: false,
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns_dropdown')
        },
        headings: {
          'createdAt': this.$t('leads.table.created_at'),
          'alarmType': this.$t('checkup_plus.alerts.table.alarmType'),
          'limitType': this.$t('checkup_plus.person.rules.limitType.title'),
          'entityEmails': this.$t('checkup_plus.alerts.table.notificationEmails'),
          'criteria': this.$t('checkup_plus.alerts.table.criteria'),
          'actions': this.$t('clinical.labels.actions')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        columnsDropdown: false,
        filterable: false,
        sortable: [],
        perPage: 10,
        pagination: {
          show: true,
          edge: true,
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          actions: 'actions',
        },
      },
      columns: ['createdAt', 'alarmType', 'limitType', 'criteria', 'entityEmails', 'actions']
    }
  },
  methods: {
    handleCriteriaLabel: function(elem) {

      if(elem.id >= 20 && elem.id <= 25) {
        return this.$t(`dashboard_new_evollu.measurement_types.body_mass_index_short`) + " - " + this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(elem.code).toLowerCase()}`)
      } else if (elem.id >= 26 && elem.id <= 28) {
        return this.$t(`dashboard_new_evollu.measurement_types.body_fat_percentage_short`) + " - " + this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(elem.code).toLowerCase()}`)
      }

      return this.$t(`dashboard_new_evollu.parameters.graphs.legends.${(elem.code).toLowerCase()}`)
    },
    handleRuleCreated: function (ruleCreated) {
      this.showToast(this.$t('checkup_plus.person.rules.rule_creation.messages.success'), this.$store.state.successToastOptions)
      this.limitRules.push(ruleCreated)
      this.showCreateRuleModal = false
    },
    handleDeleteRule: async function (elem) {
      try {

        await OneCareService.deleteLimitRule(this.person.idPerson, elem.limitRuleId)
        this.$emit('ruleDeleted', elem)
        this.showToast(this.$t('checkup_plus.person.rules.deletion.success'), this.$store.state.successToastOptions)
      } catch (error) {
        this.showToast(this.$t('entities.messages.error'), this.$store.state.errorToastOptions)
        console.log(error)
      }
    },
    createNewRule: function (){
      this.showCreateRuleModal = true
    },
    handleEntityEmails(emails) {
      if(emails && emails !== '') {
        return emails.replaceAll(';', ' ; ')
      }

      return "N/A"
    }
  }
}
</script>

<style scoped>
.actions {
  text-align: center
}
</style>
